module.exports = "# Esmeralda and Goober Closing Story\n\nYouTube: G3NNvrzdfmc\n\n## Notes\nEsmeralda gives the Apprentices their fourth mission (3:39).\n\n### Spoiler Alert\n\nThe System Manager character appears to 'hack' the Academy. Your Apprentices will be solving a puzzle to unlock the Academy at the beginning of Level 5.\n"


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/sections/60_esClosingStory/level4_closing.md
// module id = 1863
// module chunks = 2